export function createStateSyncMiddleware(options = {}) {
  const channelName = options.channelName || "redux-state-sync";
  const blacklist = options.blacklist || [];
  const whitelist = options.whitelist || [];
  const bc =
    typeof BroadcastChannel !== "undefined"
      ? new BroadcastChannel(channelName)
      : null;

  return (store) => {
    if (bc) {
      bc.onmessage = (event) => {
        if (event?.data?.type === "STATE_SYNC_ACTION") {
          const action = event.data.action;

          // Add meta to check another tab
          store.dispatch({ ...action, meta: { fromSync: true } });
        }
      };
    }

    return (next) => (action) => {
      if (action.meta?.fromSync) {
        return next(action);
      }

      const result = next(action);

      if (shouldForward(action, whitelist, blacklist)) {
        const message = { type: "STATE_SYNC_ACTION", action };
        if (bc) bc.postMessage(message);
        else localStorage.setItem(channelName, JSON.stringify(message));
      }

      return result;
    };
  };
}

function shouldForward(action, whitelist, blacklist) {
  if (blacklist.includes(action.type)) return false;
  if (whitelist.length && !whitelist.includes(action.type)) return false;
  return true;
}

export function initMessageListener(store) {
  return store;
}